import { render, staticRenderFns } from "./CompanionValuationActions.vue?vue&type=template&id=5e09e2d9&"
import script from "./CompanionValuationActions.vue?vue&type=script&lang=js&"
export * from "./CompanionValuationActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports